import { getMyPermissions } from './getMyPermissions';
import { getMyPermissionsForRescueNetApplicant } from './getMyPermissionsForRescueNetApplicant';
import { getRescueNetCompanyPermissions } from './getRescueNetCompanyPermissions';
import { getProductPermissions } from './getProductPermissions';

export const permissions = {
  getMyPermissions,
  getMyPermissionsForRescueNetApplicant,
  getRescueNetCompanyPermissions,
  getProductPermissions,
};
